import Link from 'next/link';
import { cn, shouldOpenInNewTab } from '@workspace/lib';
import { stripInvisibles } from '@workspace/constants';
import { FeatureSummaryTextLink } from './feature-summary.types';

export const RenderTextLink = ({ textLink }: { textLink?: FeatureSummaryTextLink }) => {
  const cleanText = stripInvisibles(textLink?.text || '').trim();
  if (!cleanText) return null;
  const href = (textLink?.link?.href || '').trim() || (textLink?.link?.url || '').trim();

  return href ? (
    <Link
      href={href}
      target={shouldOpenInNewTab(textLink?.link) ? '_blank' : '_self'}
      rel={shouldOpenInNewTab(textLink?.link) ? 'noopener noreferrer' : undefined}
      className={cn(
        'font-heading pt-sm',
        textLink?.isBold ? 'font-semibold' : 'font-normal',
        href && 'text-base text-primary underline hover:text-primary-500 transition-colors',
      )}
    >
      {cleanText}
    </Link>
  ) : (
    <span className={cn('font-heading pt-sm', textLink?.isBold ? 'font-bold' : 'font-normal')}>{cleanText}</span>
  );
};
